/**
 * getSectionStatus
 * ------------------------------------------------
 * DESCRIPTION_HERE
 */

import { Section } from "../../types/SectionState"
import { SectionStatus } from "../../types/SectionStatus"

export const getSectionStatus = (
  section: Section,
  isCurrentSection: boolean = false,
) => {
  const isError = section.errors
  const isTouched = section.touched

  let status: SectionStatus = "upcoming"

  if (isCurrentSection) {
    status = "current"
  } else if (section.completed) {
    status = "completed"
  } else if (isError) {
    status = "errors"
  } else if (isTouched) {
    status = "touched"
  }

  return status
}
